import gql from 'graphql-tag';

export default gql`
	mutation DeleteFieldCollection($id: ID) {
		deleteCollection(id: $id) {
			id
		}
	}
`;



// WEBPACK FOOTER //
// ./src/mutations/deleteFieldCollection.js